module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-03.ce3fcb76.jpg";